import React from 'react';
import { Badge } from '../ui/badge';
import PricingCard from '../cards/PricingCard';
import { mockData } from '../../mock';

const PricingSection = ({ scrollToContact }) => {
  return (
    <section id="pricing" className="py-32 px-6 bg-[#111111]">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-20">
          <Badge className="inline-flex items-center justify-center px-4 py-1.5 bg-gradient-to-r from-[#2F6BFF]/10 to-[#4DA3FF]/10 text-[#2F6BFF] border border-[#2F6BFF]/20 rounded-full text-sm font-medium mb-6 hover:from-[#2F6BFF]/20 hover:to-[#4DA3FF]/20 transition-all duration-300">
            Simple Pricing
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Pricing</h2>
          <p className="text-[#9AA3B2] text-lg">Simple transparent pricing — no hidden fees.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {mockData.pricing.map((plan) => (
            <PricingCard key={plan.id} plan={plan} scrollToContact={scrollToContact} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
